import { Problem, ProblemDetectionContext, ProblemType, ProblemSeverity } from '../types';

export function detectExcessiveHoldTime(context: ProblemDetectionContext, generateId: () => string): Problem[] {
  const problems: Problem[] = [];
  const { logs } = context;

  const holdLogs = logs.filter(
    (log) =>
      log.LogData?.Action?.Type === 'MessageParticipantIteratively' ||
      log.LogData?.ResourceName?.toLowerCase().includes('hold') ||
      log.LogData?.Content?.toLowerCase().includes('hold')
  );

  if (holdLogs.length >= 5) {
    const firstHoldLog = holdLogs[0];
    const lastHoldLog = holdLogs[holdLogs.length - 1];

    const duration = new Date(lastHoldLog.AbsoluteTime).getTime() - new Date(firstHoldLog.AbsoluteTime).getTime();
    const durationSeconds = duration / 1000;

    if (durationSeconds > 180) {
      // 3+ minutes
      const originalIndex = logs.indexOf(firstHoldLog);
      problems.push({
        id: generateId(),
        type: ProblemType.EXCESSIVE_HOLD_TIME,
        severity: durationSeconds > 300 ? ProblemSeverity.HIGH : ProblemSeverity.MEDIUM,
        title: 'Excessive Hold Time',
        description: `Customer was on hold for ${Math.round(durationSeconds)} seconds (${Math.round(durationSeconds / 60)} minutes)`,
        timestamp: firstHoldLog.AbsoluteTime,
        source: 'IVR_LOG',
        relatedData: { duration: durationSeconds, holdCount: holdLogs.length },
        suggestions: [
          'Review hold music and messaging strategy',
          'Consider callback options during high volume',
          'Optimize agent availability and scheduling'
        ],
        index: originalIndex >= 0 ? originalIndex : undefined
      });
    }
  }

  return problems;
}
